import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
// iter229 — StrictMode removed because react-leaflet 4 conflicts
// with React 18 StrictMode's synchronous double-mount, causing
// "Map container is already initialized." StrictMode is a dev-only
// helper; production builds are unaffected.
root.render(<App />);
